import { module } from 'modujs';
import { $html } from '../utils/dom'
import Swup from 'swup';
import SwupPreloadPlugin from '@swup/preload-plugin';
import SwupModularPlugin from '../utils/swup/SwupModularPlugin';
import SwupLSPlugin from '../utils/swup/SwupLSPlugin';
import { CSS_CLASS, CUSTOM_EVENT } from '../config';

export default class extends module {
    constructor(m) {
        super(m);

        this.onVisitStart = this.onVisitStart.bind(this);
        this.onVisitEnd = this.onVisitEnd.bind(this);
        this.beforeContentReplace = this.beforeContentReplace.bind(this);
        this.onContentReplace = this.onContentReplace.bind(this);
        this.onAnimationInStartBind = this.onAnimationInStart.bind(this);
        this.onAnimationOutStartBind = this.onAnimationOutStart.bind(this);
    }

    init() {
        const load = new Swup({
            containers: ['[data-load-container]'],
            animateHistoryBrowsing: true,
            linkToSelf: 'navigate',
            // cache: false,
            plugins: [
                new SwupLSPlugin({ modularInstance: this }),
                new SwupModularPlugin({ modularInstance: this }),
                new SwupPreloadPlugin({}),
            ]
        });

        load.hooks.on('visit:start', this.onVisitStart);
        load.hooks.on('visit:end', this.onVisitEnd);
        load.hooks.before('content:replace', this.beforeContentReplace);
        load.hooks.on('content:replace', this.onContentReplace);
        load.hooks.on('animation:in:start', this.onAnimationInStartBind);
        load.hooks.on('animation:out:start', this.onAnimationOutStartBind);
    }

    // ==========================================================================
    // HOOKS
    // ==========================================================================

    onVisitStart(visit) {
        this.call('closeModal', null, 'ModalHelp')
        this.call('closeMenu', null, 'Menu')
        this.call('updateCurrentLink', visit.to.url, 'Menu')
        this.call('buttonMouseLeave', null, 'HeroHome')
        this.call('buttonMouseLeave', null, 'CtaExperience')
    }

    onVisitEnd(visit) {
        window.dispatchEvent(new CustomEvent(CUSTOM_EVENT.VISIT_END, { detail: visit }))
    }

    async beforeContentReplace (visit) {

        if(!visit.fragmentVisit) {
            $html.scrollTop = 0;
        }
    }

    onContentReplace(visit) {
        const newLangswitcher = document.querySelector('[data-langswitcher-hidden]');
        const currentMenuLangswitcher = document.querySelector('[data-langswitcher-menu]');

        if (newLangswitcher && currentMenuLangswitcher) {
            currentMenuLangswitcher.innerHTML = newLangswitcher.innerHTML;
        }
    }

    onAnimationOutStart(visit) {
        $html.classList.remove(CSS_CLASS.READY);
    }

    onAnimationInStart(visit) {
        $html.classList.add(CSS_CLASS.READY);
    }
}
